module.exports = __webpack_public_path__ + "static/img/bg_share_third.323543b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/active/snail/riverMountain-3/bg_share_third.png
// module id = w+11
// module chunks = 1